<template>
  <div>
    <Header :actived="'myproducts'"></Header>
    <div class="product">
      <div class="title">
        <h2>My Products</h2>
        <!-- <div class="bottom-simple">Get samples</div> -->
      </div>
      <div class="product-content">
        <div class="remove" v-show="checkArr.length > 0">
          <img src="../assets/img/delete_icon.png" @click="batchRemove" />
        </div>
        <div class="search" v-show="checkArr.length == 0">
          <div class="search-content">
            <input
              type="text"
              autocomplete="off"
              v-model="page.keyword"
              placeholder="Search for products"
              @change="search"
            />
            <span class="el-input__prefix">
              <a class="search-icon-wrap">
                <img src="../assets/img/search-icon.png" class="search-icon" />
              </a>
            </span>
          </div>
        </div>
        <div class="choice clearfix">
          <button
            class="btn"
            :class="{ actived: pageStatu == 1 }"
            @click="changePageStatu('All')"
          >
            All · {{ productCount.allCount }}
          </button>
          <button
            class="btn"
            :class="{ actived: pageStatu == 2 }"
            @click="changePageStatu('Unpublished')"
          >
            Unpublished · {{ productCount.unPublishedCount }}
          </button>
          <button
            class="btn"
            :class="{ actived: pageStatu == 3 }"
            @click="changePageStatu('Published')"
          >
            Published · {{ productCount.publishedCount }}
          </button>
          <button
            class="btn"
            :class="{ actived: pageStatu == 4 }"
            @click="changePageStatu('Hidden')"
          >
            Hidden in store · {{ productCount.hiddenInStoreCount }}
          </button>
          <a-button
            v-if="CurrentShop.shopType == 2 && checkArr.length > 0"
            class="btn"
            style="margin-left: 20px"
            @click="exportProduct()"
            >Export product</a-button
          >
          <div class="copy-product">
            <a-button
              type="primary"
              @click="copyProduct"
              :disabled="checkArr.length == 0"
              >Copy Product</a-button
            >
            <span>{{ checkArr.length }} selected</span>
          </div>
        </div>
        <div class="checkall">
          <a-checkbox @change="onCheckAllChange" :checked="checkArr.length > 0">
            All
          </a-checkbox>
        </div>
        <div>
          <div class="infinite-list">
            <a-checkbox-group
              style="width: 100%;"
              class="checkd"
              v-model="checkArr"
              @change="onChangeCheck($event)"
            >
              <div
                class="my-product"
                v-for="(item, index) in pageList"
                :key="index"
              >
                <div class="check">
                  <a-checkbox :value="item.id"></a-checkbox>
                </div>
                <div class="my-product-img">
                  <img :src="item.mainImageUrl" @click="_preViewImg(item)" />
                </div>
                <div class="my-product-con">
                  <div class="my-product-top">
                    <alerts
                      v-if="item.isBlankProductSkuUpdate"
                      @alert="alertFn(item, index)"
                    ></alerts>
                  </div>
                  <div class="my-product-bottom">
                    <div class="my-product-introduce">
                      <h4>{{ item.title }}</h4>
                      <h6>{{ item.blankProductModel }}</h6>
                      <h6 v-if="item.option1Name">
                        {{ item.option1Name }}：{{ item.option1Num }}
                      </h6>
                      <h6 v-if="item.option2Name">
                        {{ item.option2Name }}：{{ item.option2Num }}
                      </h6>
                      <h6 v-if="item.option3Name">
                        {{ item.option3Name }}：{{ item.option3Num }}
                      </h6>
                      <!-- <p>Retail prices: ${{item.price}}</p> -->
                    </div>
                    <div class="product-action">
                      <a-button
                        type="primary"
                        class="product-botton"
                        v-if="item.status == 2 && item.status != 3"
                        @click="url(item, 1)"
                        size="large"
                        >See in store</a-button
                      >
                      <a-button
                        type="primary"
                        class="product-botton"
                        v-if="
                          (item.status == 1 && CurrentShop.shopType == 1) ||
                            (item.status == 1 && CurrentShop.shopType == 3)
                        "
                        size="large"
                        :loading="iconLoading && !item.disabled"
                        :disabled="item.disabled"
                        @click="pushShopify(item.id, index)"
                        >Publish</a-button
                      >
                      <a-button
                        v-if="item.customizable"
                        size="large"
                        style="margin-left: 20px"
                        @click="goMockups(item)"
                        >Edit Product</a-button
                      >
                    </div>
                    <div class="product-set" @click="batchRemoveFirst(item.id)">
                      <img src="../assets/img/delete_icon.png" />
                    </div>
                    <a-dropdown>
                      <div class="product-set" @click="e => e.preventDefault()">
                        <img src="../assets/img/setting.png" />
                      </div>
                      <a-menu slot="overlay" @click="onClick">
                        <a-menu-item
                          key="1"
                          @click="hideShopify(item.id)"
                          v-if="item.status === 2 && !item.isHiddenInStore"
                          >Hide on Shopify</a-menu-item
                        >
                        <a-menu-item
                          key="1"
                          @click="showShopify(item.id)"
                          v-if="item.status === 2 && item.isHiddenInStore"
                          >Show on Shopify</a-menu-item
                        >
                        <a-menu-item
                          key="2"
                          @click="url(item, 1)"
                          v-if="
                            (item.status == 2 && CurrentShop.shopType == 1) ||
                              (item.status == 2 && CurrentShop.shopType == 3)
                          "
                          >See in store</a-menu-item
                        >
                        <a-menu-item key="3" @click="goOrder"
                          >Create an order</a-menu-item
                        >
                        <a-menu-item key="4" @click="batchRemoveFirst(item.id)"
                          >Delete</a-menu-item
                        >
                      </a-menu>
                    </a-dropdown>
                  </div>
                </div>
              </div>
            </a-checkbox-group>
          </div>
        </div>
      </div>
      <div style="float: right">
        <a-pagination
          size="large"
          :current="page.current"
          :pageSize="page.size"
          :total="pageTotal"
          show-size-changer
          show-quick-jumper
          @change="pageChange"
          @showSizeChange="sizeChange"
        />
      </div>
    </div>
    <!-- 推送引导弹窗 -->
    <div class="dialog" v-if="isyindao">
      <div class="d-yindao">
        <div class="icon">
          <a-icon
            type="info-circle"
            :style="{ fontSize: '20px', color: '#08c' }"
          />
        </div>
        <div class="html" v-html="yindao"></div>
        <div class="dialog-btn">
          <a-button type="primary" @click="isyindao = false">ok</a-button>
          <a-button class="bord" @click="goWrite">
            Write a review
          </a-button>
        </div>
      </div>
    </div>
    <!-- 查看图片弹框 -->
    <div class="dialog" v-if="isPreview">
      <div class="d-content">
        <a-row style="height: 100%">
          <a-col :span="15">
            <div class="d-img">
              <img :src="preViewImg" />
              <a-button type="primary" @click="closePreview">
                <a-icon type="left" />Return
              </a-button>
            </div>
          </a-col>
          <a-col :span="9" style="position: absolute;height: 100%;right: 0;">
            <ul class="clearfix">
              <!-- :class="{ actived: pageStatu == 1 }" -->
              <li
                :class="{ actived: previewIndex == index }"
                v-for="(item, index) in previewList"
                :key="index"
              >
                <img :src="item" @click="changePreview(index)" />
              </li>
            </ul>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="loading" v-show="loading">
      <div class="loading-load">
        <a-spin size="large" tip="loading..." />
      </div>
    </div>
    <div v-if="skuUpdateIsShow">
      <skuUpdate
        ref="skuUpdate"
        :productId="choiceProduct.blankProductId"
        :cusId="choiceProduct.id"
        :skuUpdateIsShow="skuUpdateIsShow"
        @close="closeSkuUpdate"
        @setSkuPrice="setSkuPrice"
      ></skuUpdate>
    </div>
    <priceUpdate
      ref="priceUpdate"
      :cusId="choiceProduct.id"
      :status="choiceProduct.status"
      :priceUpdateIsShow="priceUpdateIsShow"
      :skuPrice="skuPrice"
      @close="closePriceUpdate"
      v-if="priceUpdateIsShow"
    ></priceUpdate>
  </div>
</template>
<script>
import Header from "../components/Header";
import skuUpdate from "@/components/skuUpdate";
import { mapState, mapMutations } from "vuex";
import priceUpdate from "@/components/priceUpdate.vue";
import alerts from "@/components/alerts";
import {
  publish,
  publishStatus,
  productPage,
  delProduct,
  productCount,
  batchDelProduct,
  hideOnShopify,
  showOnShopify,
  productExport
} from "@/api/product";
export default {
  components: {
    Header,
    skuUpdate,
    priceUpdate,
    alerts
  },
  data() {
    return {
      choiceProduct: "",
      isyindao: false,
      yindao: "",
      pushIndex: -1,
      iconLoading: false, //按钮loading
      previewIndex: 0,
      previewList: [], //预览图片列表
      preViewImg: "", //预览图片主图
      isPreview: false,
      loading: true,
      actived: "myproducts",
      pageList: [],
      setInter: "",
      pageStatu: 1,
      checkArr: [],
      value: [],
      productCount: {}, //产品统计
      pageTotal: 1,
      page: {
        current: 1,
        size: 10,
        keyword: "", //关键字
        status: "",
        isHiddenInStore: null
      },
      skuUpdateIsShow: false,
      priceUpdateIsShow: false,
      skuPrice: []
    };
  },
  computed: {
    ...mapState({
      IsPullProduct: state => state.User.isPullProduct,
      IsPushProduct: state => state.User.isPushProduct,
      CurrentShop: state => state.User.merchantInfo.currentShop
    })
  },
  updated() {
    if (this.IsPullProduct == true) {
      this.pageList = [];
      this.inits();
      this.IsPullProductMutations(false);
    }
  },
  mounted() {
    this.inits();
  },
  methods: {
    ...mapMutations("User", [
      "IsPullProductMutations",
      "IsPushProductmutations"
    ]),
    async copyProduct() {
      const _this = this;
      this.$confirm({
        title: `Copy ${_this.checkArr.length} products to …`,
        content:
          "Due to sales channel limitations some sales channel specific product details like product description text formating and tags might be lost in copy process",
        async onOk() {
          _this.$router.push({
            path: "/copyOnceProduct",
            query: {
              customProductId: JSON.stringify(_this.checkArr),
              shopId: _this.CurrentShop.shopId,
              productNum: _this.checkArr.length
            }
          });
        },
        onCancel() {}
      });
    },
    //全选所有产品
    onCheckAllChange(e) {
      if (e.target.checked) {
        for (let index = 0; index < this.pageList.length; index++) {
          this.checkArr.push(this.pageList[index].id);
        }
      } else {
        this.checkArr = [];
      }
    },
    async inits() {
      //获取分页
      await this.getProduct();
      //产品统计
      {
        let { data } = await productCount();
        this.productCount = data;
      }
      // const id = this.$route.query.id;
      //0不推送，1推送
      const id = this.IsPushProduct;
      if (id) {
        this.IsPushProductmutations(null);
        const pageList = this.pageList;
        for (let i = 0; i < pageList.length; i++) {
          if (pageList[i].id != id) {
            this.pageList[i].disabled = true;
          }
        }
        this.pageList = pageList;
        let { data } = await publish({
          customProductId: id
        });
        this.pushStatu(data.customProductPublishId, 0); //0不用重新加载分页  1重新加载分页
      }
    },
    async pushStatu(id, index) {
      const _this = this;
      this.pushIndex = index;
      const customProductPublishId = id;
      this.iconLoading = true;
      for (;;) {
        let { data } = await publishStatus({
          customProductPublishId: customProductPublishId
        });
        if (data.status == 2) {
          //是否显示推送引导弹窗
          if (data.introduceText) {
            _this.isyindao = true;
            _this.yindao = data.introduceText;
          }
          //发布成功
          _this.pageList = [];
          _this.getProduct();
          _this.iconLoading = false;
          _this.pushIndex = -1;
          for (let i = 0; i < this.pageList.length; i++) {
            if (this.pageList[i].id != this.$route.query.id) {
              this.pageList[i].disabled = false;
            }
          }
          break;
        } else if (data.status == 3) {
          //发布失败
          _this.iconLoading = false;
          _this.$message.error("pull failed");
          _this.pushIndex = -1;
          for (let i = 0; i < this.pageList.length; i++) {
            if (this.pageList[i].id != this.$route.query.id) {
              this.pageList[i].disabled = false;
            }
          }
          break;
        }
        await new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 500);
        });
      }
    },
    //导出产品
    async exportProduct() {
      let { data } = await productExport({ customProductIds: this.checkArr });
      window.location.href = data;
    },
    //推送到shopify
    async pushShopify(id, index) {
      for (let i = 0; i < this.pageList.length; i++) {
        if (this.pageList[i].id != id) {
          this.pageList[i].disabled = true;
        }
      }
      this.iconLoading = true;
      let { code, data } = await publish({ customProductId: id });
      if (code == 200) {
        this.pushStatu(data.customProductPublishId, index); //0不用重新加载分页  1重新加载分页
      } else {
        this.iconLoading = false;
      }
    },
    //关闭图片预览
    closePreview() {
      this.previewIndex = 0;
      this.isPreview = false;
    },
    //更改预览图
    changePreview(index) {
      console.log(index);
      this.previewIndex = index;
      this.preViewImg = this.previewList[index];
    },
    //预览图片
    _preViewImg(item) {
      this.previewList = item.imageList;
      this.preViewImg = item.imageList[0];
      this.isPreview = true;
    },
    pageChange(current) {
      this.checkArr = [];
      this.pageList = [];
      this.page.current = current;
      this.getProduct();
    },
    sizeChange(current, pageSize) {
      this.checkArr = [];
      this.pageList = [];
      this.page.current = current;
      this.page.size = pageSize;
      this.getProduct();
    },

    //去编辑产品
    goMockups(item) {
      this.$router.push({
        path: "mockups",
        query: {
          customProductId: item.id,
          productId: item.blankProductId
        }
      });
    },
    // 隐藏再shopify
    async hideShopify(id) {
      const _this = this;
      let { code, msg } = await hideOnShopify({
        customProductId: id
      });
      if (code == 400) {
        this.$message.error(msg);
      } else {
        _this.page.current = 0;
        _this.pageList = [];
        _this.getProduct();
        _this.checkArr = [];
      }
    },
    // 隐藏再shopify
    async showShopify(id) {
      const _this = this;
      _this.loading = true;
      let { code, msg } = await showOnShopify({
        customProductId: id
      });
      if (code == 400) {
        _this.loading = false;
        this.$message.error(msg);
      } else {
        _this.loading = false;
        _this.page.current = 0;
        _this.pageList = [];
        _this.getProduct();
        _this.checkArr = [];
      }
    },
    //删除单个
    batchRemoveFirst(id) {
      const _this = this;
      const arr = [];
      arr.push(id);
      this.$confirm({
        title: "Delete?",
        content: "Are you sure you want to delete these products?",
        okText: "Delete",
        cancelText: "cancel",
        onOk: async function() {
          await batchDelProduct({
            customProductIdList: arr
          });
          _this.page.current = 0;
          _this.pageList = [];
          _this.getProduct();
          _this.checkArr = [];
        },
        onCancel: function() {
          console.log("cancel....");
        }
      });
    },
    async batchRemove() {
      const _this = this;
      this.$confirm({
        title: "Delete?",
        content: "Are you sure you want to delete these products?",
        okText: "Delete",
        cancelText: "cancel",
        onOk: async function() {
          await batchDelProduct({
            customProductIdList: _this.checkArr
          });
          _this.page.current = 0;
          _this.pageList = [];
          _this.getProduct();
          _this.checkArr = [];
        },
        onCancel: function() {
          console.log("cancel....");
        }
      });
    },
    //选择产品
    async onChangeCheck(e) {
      this.checkArr = e;
      console.log(this.checkArr);
    },
    //删除产品(一个)
    async removeOneProduct(id) {
      await delProduct({
        customProductId: id
      });
    },
    changePageStatu(val) {
      this.pageList = [];
      this.page.current = 1;
      if (val == "All") {
        this.page.status = "";
        this.page.isHiddenInStore = false;
        this.pageStatu = 1;
      } else if (val == "Unpublished") {
        this.page.status = 1;
        this.page.isHiddenInStore = false;
        this.pageStatu = 2;
      } else if (val == "Published") {
        this.page.status = 2;
        this.page.isHiddenInStore = false;
        this.pageStatu = 3;
      } else if (val == "Hidden") {
        this.page.status = "";
        this.page.isHiddenInStore = true;
        this.pageStatu = 4;
      }
      this.getProduct();
    },
    url(item, val) {
      if (val == 1) {
        window.open(item.productStoreUrl);
      }
    },
    onClick({ key }) {
      console.log(`Click on item ${key}`);
    },
    search() {
      this.page.current = 1;
      this.pageList = [];
      this.getProduct();
    },
    // 分页
    async getProduct() {
      this.loading = true;
      const _this = this;
      let { data } = await productPage({
        current: this.page.current,
        size: this.page.size,
        keyword: this.page.keyword,
        status: this.page.status,
        isHiddenInStore: this.page.isHiddenInStore
      });
      this.pageTotal = data.total;
      if (data.records) {
        for (let i = 0; i < data.records.length; i++) {
          data.records[i].disabled = false;
          _this.pageList.push(data.records[i]);
        }
      }
      this.loading = false;
    },
    goOrder() {
      this.$router.push({
        path: "/orderlist",
        query: { isOrder: true, isSamples: false }
      });
    },
    goWrite() {
      window.open("https://apps.shopify.com/jetprint-fulfillment/reviews");
    },
    alertFn(item, index) {
      this.choiceProduct = item;
      this.skuUpdateIsShow = true;
      console.log(item, index);
    },
    openPriceUpdate() {
      this.priceUpdateIsShow = true;
    },
    closePriceUpdate(val) {
      if (val == 1) {
        this.pageList = [];
        this.inits();
      }
      this.priceUpdateIsShow = false;
    },
    closeSkuUpdate() {
      this.skuUpdateIsShow = false;
    },
    setSkuPrice(val) {
      this.skuUpdateIsShow = false;
      this.skuPrice = val;
      this.priceUpdateIsShow = true;
    }
  }
};
</script>
<style scoped lang="scss">
@import "../assets/css/preview.scss";
.remove {
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.remove img {
  width: 30px;
  height: 30px;
  margin-left: 30px;
  cursor: pointer;
}
.product {
  max-width: 1168px;
  margin: 0 auto;
}
.product .title {
  margin-top: 20px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
}
.product h2 {
  font-family: CerebriSans, sans-serif;
  font-weight: 500;
  line-height: 1.19;
  font-size: 33px;
  letter-spacing: -1px;
  text-align: left;
}
.product .bottom-simple {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  -webkit-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  border-radius: 4px;
  width: 140px;
  text-align: center;
  font-size: 18px;
  color: rgba(56, 56, 56, 0.6);
  border: 1px solid rgba(56, 56, 56, 0.3);
}
.product .bottom-simple:hover {
  border: 1px solid #333;
  color: #333;
}
.product .product-content {
  margin: 24px;
  position: relative;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(133, 123, 123, 0.25),
    0 2px 3px hsla(0, 0%, 58%, 0.15), 0 0 2px hsla(0, 0%, 58%, 0.1);
  background-color: #fff;
  color: #383838;
  text-align: left;
  overflow: hidden;
}
.product .search {
  padding: 12px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.product .search-content {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 100%;
}
.product .search input {
  border: none;
  -webkit-appearance: none;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 30px;
  padding-left: 30px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.product .search input::-webkit-input-placeholder {
  color: rgba(56, 56, 56, 0.5);
  font-weight: bold;
}
.product .search span {
  left: 5px;
  transition: all 0.3s;
  position: absolute;
  top: 0;
  height: 100%;
  color: #c0c4cc;
  text-align: center;
}
.product .search a {
  display: inline-block;
  line-height: 36px;
}
.product .search img {
  width: 18px;
  vertical-align: middle;
}
.product .my-product {
  padding: 32px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
}
.product .my-product-msg {
  width: 100%;
}
.product .my-product-msg .check {
  width: 50px;
}
.product .my-product-img {
  margin-left: 15px;
  width: 142px;
  height: 142px;
  margin-right: 24px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.product .my-product-img img {
  width: 138px;
  height: 138 px;
}
.product .my-product-con {
  flex: 1;
  .my-product-bottom {
    margin-top: 10px;
    display: flex;
  }
}
.checkd {
  .check {
    margin-top: 63px;
  }
}
.product .my-product-introduce {
  height: 100%;
  width: calc(100% - 66px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.product .my-product-introduce h4 {
  font-family: Microsoft YaHei;
  margin-top: 0;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}
.product .my-product-introduce p {
  color: rgba(56, 56, 56, 0.5);
  padding-top: 5px;
}
.product .product-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.product .product-action .product-botton {
  width: 140px;
  text-align: center;
  font-size: 18px;
  border: 0px;
  font-weight: bold;
}
// .product .product-action .product-botton:hover {
//   background-color: #3dbfcc;
//   border-color: #3dbfcc;
// }
.product .product-set {
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-left: 24px;
  cursor: pointer;
}
.product-set img {
  width: 18px;
}
.choice {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 20px;
}
.copy-product {
  float: right;
  width: 121px;
  text-align: center;
}
.checkall {
  padding-left: 24px;
  padding-top: 16px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 16px;
}
.choice .btn {
  display: block;
  padding: 0 16px;
  border-radius: 18px;
  background-color: #f7f7f7;
  color: #1b1b1b;
  line-height: 36px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 0;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.choice .btn:hover {
  background-color: #f7f5f2;
}
.choice .btn.actived {
  background-color: #1b1b1b;
  color: white;
}
@media screen and (max-width: 600px) {
  .product .my-product-img img {
    width: 46px;
    height: 46px;
  }
  .product .my-product-img {
    width: 46px;
    height: 46px;
    margin-right: 24px;
  }
}
</style>
